import styled from 'styled-components';

export const StyledTranslationsPage = styled.div``;
